module.exports = __webpack_public_path__ + "static/couple-sitted-face-left-350w-2b7468c0632b2c625bb5e1aa5ef867af.png";